<template>
  <div class="container" style="margin-top: 3cm">
    <h2 class="text-center">2023年四川省企业管理创新大会在乐山举行</h2>
    <p class="box_p text-center">
      <span>发布时间： </span>
      <span id="date" style="display: inline-block; margin-left: -10px">
         2024-06-21 13:11:33
        </span>
      <span style="margin-left: 16px">编辑： </span>
      <span id="author" style="display: inline-block; margin-left: -10px">
         管理员
        </span>
    </p>
    <div  style="letter-spacing:2px;margin-bottom: 5cm">
      &nbsp;   5月12日，由四川省企业联合会、四川省企业家协会主办，福华通达化学股份公司协办的“2023年四川省企业管理创新大会”在乐山召开。<br/>
      &nbsp;&nbsp;&nbsp;&nbsp;会议以“深入推进企业管理创新 加快建设世界一流企业”为主题，来自全省各市州工业和信息化主管部门、企业联合会、行业协会以及有关企业的负责人、2022年度省级管理创新成果创造单位代表和优秀论著文作者、高等院校和科研机构专家以及新闻媒体代表，共180余人参加了会议。<br/>
      &nbsp;&nbsp;&nbsp;&nbsp;中国企业联合会常务副理事长史向辉、四川省经济和信息化厅总经济师袁冰、四川省国有资产监督管理委员会二级巡视员韩宝顺、中国企业联合会智慧企业推进委员会秘书长、企业创新工作部主任张文彬、四川省企业联合会/企业家协会副会长徐杰、四川省企业联合会/企业家协会副秘书长（主持工作）、四川省企业管理创新工作委员会秘书长伍晓绯、四川省企业联合会/企业家协会副秘书长陶英、四川省企业管理创新工作委员会副理事长王刚、四川省企业管理现代化创新成果审定委员会顾问何林虎、福华通达化学股份公司副总经理李瑞琪等出席会议。四川省企业联合会/企业家协会副会长李继郁主持会议。<br/>
      &nbsp;&nbsp;&nbsp;&nbsp;史向辉副理事长做大会致辞。袁冰总经济师与韩宝顺巡视员分别做致辞讲话，祝贺会议召开和获奖的企业与个人，并结合当前经济、社会形势对企业如何通过创新来实现高质量发展、争创世界一流提出意见和建议。徐杰副会长作会议主旨报告。报告总结了2022年度省企联管理创新工作及获得的成绩，从优秀成果中甄选代表性案例概括阐述了申报成果的亮点和创新之处，并结合党的二十大精神和习近平新时代中国特色社会主义思想，对企业如何贯彻落实新发展理念，以管理创新推动企业高质量发展提出建设性意见，也为企业从哪些重点领域推进管理创新，推动成果培育、转化提出了建议和要求。<br/>
      &nbsp;&nbsp;&nbsp;&nbsp;伍晓绯副秘书长（主持工作）发布2022年度国家级和省级管理创新成果和优秀论（著）文名单：共172项成果被评为2022年度四川省级企业管理现代化创新成果，94篇论(著)文被评为省年度优秀论(著)文。推荐5项我省优秀成果参评第二十九届国家级管理创新成果，最终全部获奖，位列全国前茅。<br/>
      &nbsp;&nbsp;&nbsp;&nbsp;本次会议特别邀请中国企业联合会智慧企业推进委员会秘书长、企业创新工作部主任张文彬做专题演讲，向企业讲授如何发掘、创造、申报管理创新成果奖和学习、利用成果经验推动企业的管理水平可持续提升。<br/>
      &nbsp;&nbsp;&nbsp;&nbsp;福华通达化学股份公司、宜宾丝丽雅集团有限公司、中国电子科技集团公司第十研究所3家企业作为优秀企业代表做管理创新经验交流，分享企业创新发展经验。<br/>
      &nbsp;&nbsp;&nbsp;&nbsp;大会详细图文直播请点击<a href="https://wx.vzan.com/live/tvchat-268985973?v=638194201424438768" style="color: cornflowerblue;">https://wx.vzan.com/live/tvchat-268985973?v=638194201424438768观看。</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/NewsDetails.vue